import React, { useEffect } from 'react'

import ContainerBar from 'components/Sections/ContainerBar'

import CustomOpcion from 'theme/wrappers/CustomOption'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  FormControlLabel,
  Checkbox,
  FormGroup,
  Box,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core'

import { useSelector } from 'react-redux'
import { getSubCategory } from 'utils/configQueries'
import useStyles from './styles'

const ThematicMaps = ({

  title, options, selected, onChangeSelected
}) => {
  const classes = useStyles()
  const categoriesColor = useSelector((state) => state.categories.color)
  const idCategory = useSelector((state) => state.categories.sectionId[0])
  const layers = getSubCategory(idCategory).map(({ layers }) => layers).flatMap((e) => e)
  const dataLayers = options?.map((element) => element)

  let lastTitle = null
  dataLayers.forEach((_, i) => {
    if (dataLayers[i]?.title === lastTitle) {
      dataLayers[i].title = null
    } else {
      lastTitle = dataLayers[i].title
    }
  })

  const data = dataLayers.map(({ title }) => title)
  const subTitle = data?.filter((data) => data !== null)

  const subcategoryLayers = subTitle?.map((data) => ({
    title: data,
    layers: layers.filter(({ subTitle }) => subTitle === data)
  }))

  return (
    <ContainerBar style={{ padding: '0' }} type="list">
      <Box data-tut="subcategory">
        <Box className={classes.container}>
          <Typography variant="h5" className={classes.sectionTitle} style={{ color: categoriesColor }}>
            {title}
          </Typography>
        </Box>
        <FormGroup className={classes.formGroup}>
          {subcategoryLayers?.map(({
            title, layers
          }) => (
            <Box className={classes.subCategory}>
              <Accordion key={title}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                >
                  {!!title && (
                    <>
                      {title}
                      <br />
                    </>
                  )}
                </AccordionSummary>
                <AccordionDetails expandIcon={<ExpandMoreIcon />} style={{ display: 'flex', flexDirection: 'column' }}>
                  {layers.map(({ name, title, id, description }) => {
                    const isChecked = selected?.includes(id)
                    return (
                      <>
                        <FormControlLabel
                          className={classes.subtile}
                          key={title}
                          control={(
                            <Checkbox
                              checked={isChecked}
                              icon={<RadioButtonUncheckedIcon />}
                              checkedIcon={<CustomOpcion style={{ backgroundColor: 'white', color: categoriesColor }} />}
                              onChange={() => onChangeSelected(id, !isChecked)}
                            />
                      )}
                          label={(
                            <Typography className={classes.capa}>
                              {description || name}
                            </Typography>
                          )}
                        />
                        <Divider />
                      </>
                    )
                  })}
                </AccordionDetails>
              </Accordion>
            </Box>
          ))}
        </FormGroup>
      </Box>
    </ContainerBar>
  )
}

export default ThematicMaps
